import classNames from 'classnames';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { SELECTORS } from '../../../../../../../../../constants';
import TextSearch from '../../../../../../../../common/TextSearch';
import * as perspectives from '../../../../../constants/perspectives';
import LargeHeroContainer from './LargeHeroContainer';

import styles from './LargeHero.less';

const perspectiveMappings = Map({
  [perspectives.DISCOVER]: Map({
    className: styles.discoverHero,
    textSearchMode: 'hero',
  }),
  [perspectives.SEARCH]: Map({ className: styles.searchHero, textSearchMode: 'header' }),
});

export default class LargeHero extends Component {
  static propTypes = {
    discoverHeading: PropTypes.string.isRequired,
    query: PropTypes.string,
    perspective: perspectives.propType.isRequired,
    onChangeQuery: PropTypes.func.isRequired,
    onClick: PropTypes.func,
  };

  render() {
    return (
      <div className={styles.largeHeroWrapper}>
        <div className={styles.largeHeroInnerWrapper}>
          <div className={styles.textSearchContainer}>
            <div
              className={classNames([
                styles.textSearch,
                // @ts-expect-error [MC-2850] - TS2339 - Property 'perspective' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
                perspectiveMappings.getIn([this.props.perspective, 'className']),
              ])}
            >
              <TextSearch
                // @ts-expect-error [MC-2850] - TS2339 - Property 'perspective' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
                focusOnMount={this.props.perspective === perspectives.DISCOVER}
                // @ts-expect-error [MC-2850] - TS2339 - Property 'query' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
                query={this.props.query}
                // @ts-expect-error [MC-2850] - TS2339 - Property 'onChangeQuery' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
                onChange={this.props.onChangeQuery}
                // @ts-expect-error [MC-2850] - TS2339 - Property 'perspective' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
                mode={perspectiveMappings.getIn([this.props.perspective, 'textSearchMode'])}
                name={SELECTORS.INPUT_NAME_HEADER_SEARCH_BOX}
                // @ts-ignore
                onClick={this.props.onClick}
              />
            </div>
          </div>
          <LargeHeroContainer
            // @ts-expect-error [MC-2850] - TS2339 - Property 'discoverHeading' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
            discoverHeading={this.props.discoverHeading}
            // @ts-expect-error [MC-2850] - TS2339 - Property 'perspective' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
            perspective={this.props.perspective}
          />
        </div>
      </div>
    );
  }
}
